import React from "react";
import PropTypes from "prop-types";

import RichEditor from "../RichEditor/RichEditor";

export const FormRichEditor = ({ input, meta }) => {
  const { touched, submitFailed, error } = meta;
  const hasError = (touched || submitFailed) && error;

  return (
    <fieldset>
      {hasError && <span className="input__error">*{error}</span>}
      <div className="input__wrapper">
        <RichEditor initialValue={input.value} onChange={input.onChange} />
      </div>
    </fieldset>
  );
};

FormRichEditor.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    submitFailed: PropTypes.bool,
    error: PropTypes.string
  })
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormRichEditor.js